import { render, staticRenderFns } from "./navList.vue?vue&type=template&id=361a3edc&scoped=true"
import script from "./navList.vue?vue&type=script&lang=js"
export * from "./navList.vue?vue&type=script&lang=js"
import style0 from "./navList.vue?vue&type=style&index=0&id=361a3edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361a3edc",
  null
  
)

export default component.exports